import { z } from 'zod';

/**
 * Where a cached AI response's payload lives (N15).
 *
 * `db` keeps the value in `ai.ai_cache_entries.value` (jsonb); `object` writes
 * it to the private bucket through the `storage` capability and keeps only the
 * hidden storage key on the row. The choice is the `ai.cache.storage` setting,
 * and it is per **deployment**, not per entry — but the column records what a
 * given row actually used, because a policy change must not orphan the bytes of
 * entries written under the previous one.
 *
 * Declared here rather than inline in the settings definition so the definition,
 * the strategy registry, the table enum and the admin filter are the same list
 * (U3).
 */
export const AI_CACHE_STORAGES = ['db', 'object'] as const;

export const AiCacheStorageSchema = z.enum(AI_CACHE_STORAGES);

export type AiCacheStorage = (typeof AI_CACHE_STORAGES)[number];

const STORAGE_SET: ReadonlySet<string> = new Set<string>(AI_CACHE_STORAGES);

/** Narrows a stored column — a row written before a strategy was renamed. */
export function isAiCacheStorage(value: string): value is AiCacheStorage {
  return STORAGE_SET.has(value);
}
